import PropTypes from 'prop-types';
import { use } from 'react';
import { Trans } from 'react-i18next';

import UserContext from '../../contexts/UserContext';

import HomeStructure from './HomeStructure';

const HomeSlim = ({ testId }) => {
  const { isAdmin } = use(UserContext);

  return (
    <HomeStructure
      description={
        isAdmin ? (
          <Trans i18nKey={'Global.WelcomeDashboardNoSpaceAdmin'} />
        ) : (
          <Trans i18nKey={'Global.WelcomeDashboardNoSpace'} />
        )
      }
      testId={testId}
      welcomeImage
    />
  );
};

export default HomeSlim;

HomeSlim.propTypes = {
  /**
   * Test id for home slim page
   */
  testId: PropTypes.string,
};
